import React from "react";

import GroupPanel from "./GroupPanel";
import { Groups } from "../projects/Groups";

// import { tvInteractive } from "../img/projImgsObj";

class GroupPanels extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            groups: [...Groups]
        };
    }

    makeGroups = (Groups) => {
        return Groups.map((group, index) => 
            <GroupPanel
                key={index}
                title={group.title}
                subtitle={group.subtitle}
                img={group.img}
                link={group.link}
            />
        )
    }

    render() {
        return (
            <div className="GroupPanels">
                {this.makeGroups(this.state.groups)}
            </div>
        );
    }
}

export default GroupPanels;